import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class AddUserToWaitingList {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * AddUserToWaitingList constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Save incomplete registrant information via API for delivery address waiting list.
     *
     * @param {Object} incompleteRegistrant
     *
     * @returns {Promise}
     */
    handle(incompleteRegistrant) {
        return this.apiService
            .post(ApiEndpoints['delivery-waiting-list.store'], {
                'coupon_code': incompleteRegistrant.couponCode,
                'coupon_source': incompleteRegistrant.couponSource,
                'email': incompleteRegistrant.email,
                'first_name': incompleteRegistrant.firstName,
                'last_name': incompleteRegistrant.lastName,
                'postcode': incompleteRegistrant.postcode,
            });
    }
}
